/**
 * Parses 422 error responses from the API into a flat Record<string, string>.
 *
 * Handles both snake_case and camelCase keys since the axios error path
 * may skip the humps camelization interceptor. Supports error responses
 * in string, array, or object formats.
 *
 * @returns Parsed errors or null if the error is not a 422 response
 */
export function parseServerErrors(err: unknown): Record<string, string> | null {
  const axiosErr = err as { response?: { status?: number; data?: Record<string, unknown> } }

  if (axiosErr.response?.status !== 422) return null

  const data = axiosErr.response.data
  if (!data) return null

  const raw = (data.errors || data.error) as unknown
  if (!raw) return null

  const result: Record<string, string> = {}

  if (typeof raw === 'string') {
    result.general = raw
  } else if (Array.isArray(raw)) {
    result.general = raw.join(', ')
  } else if (typeof raw === 'object') {
    for (const [key, val] of Object.entries(raw as Record<string, unknown>)) {
      const camelKey = key.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase())
      result[camelKey] = Array.isArray(val) ? val.join(', ') : String(val)
    }
  }

  return Object.keys(result).length > 0 ? result : null
}
